import type { FederatedSearchAnalyticsOutcome } from '~/utils/searchEngineHelpers'
import {
  consumeFederatedSearchAnalyticsOutcome,
  setFederatedSearchAnalyticsOutcome,
} from '~/utils/federatedSearchAnalyticsSession'

export const useFederatedSearchAnalyticsSession = () => ({
  setFederatedSearchAnalyticsOutcome: (
    outcome: FederatedSearchAnalyticsOutcome
  ) => setFederatedSearchAnalyticsOutcome(outcome),

  consumeFederatedSearchAnalyticsOutcome: () =>
    consumeFederatedSearchAnalyticsOutcome(),
})
